function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-90 -634)",
  fill: "#f00",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "m108.68 651.2l-4.6597-4.6653c2.3429-3.0494 2.1086-7.454-0.70286-10.243-1.5359-1.5377-3.5143-2.2936-5.5187-2.2936s-3.9829 0.75583-5.5187 2.2936c-3.0457 3.0494-3.0457 8.0014 0 11.051 1.5359 1.5377 3.5143 2.2936 5.5187 2.2936 1.666 0 3.3321-0.52126 4.7117-1.5898l4.6857 4.6392c0.20825 0.2085 0.46857 0.31276 0.75492 0.31276 0.26032 0 0.54667-0.10425 0.75492-0.31276 0.39048-0.39095 0.39048-1.0686-0.026032-1.4856zm-11.035-4.0072c-1.4938 0-2.861-0.582-3.9244-1.6195-2.1521-2.1509-2.1521-5.6682 0-7.8444 1.0381-1.0375 2.4306-1.6195 3.9244-1.6195 1.4938 0 2.861 0.582 3.9244 1.6195s1.6204 2.4292 1.6204 3.9222c0 1.493-0.58233 2.8594-1.6204 3.9222-1.0381 1.0628-2.4559 1.6195-3.9244 1.6195z"
})));

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.65fc0278.svg";
export { ForwardRef as ReactComponent };